import {
  GET_TEMPLATES,
  CREATE_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_TEMPLATE_BY_ID,
  UPDATE_STAGE_FIELDS,
  SET_TEMPLATE_ACTIVE_STATUS,
  GET_VO_TEMPLATES_AND_STAGES,
  GET_CS_TEMPLATES_AND_STAGES,
  UPDATE_CURRENT_STAGE_FOR_DEPARTMENT,
} from './templates';

import {
  COMPLETE_STAGE,
  GET_STAGE_NOTES,
  CREATE_STAGE_NOTE,
  GET_STAGES_TIMELINE,
  GET_STAGES_BY_DEPARTMENT,
} from './stages';

import {
  GET_CLOSE_REASONS,
  CREATE_CLOSE_REASON,
  DELETE_CLOSE_REASON,
  CREATE_CLOSE_REASONS,
  GET_CLOSE_REASONS_OPTIONS,
  UPDATE_CLOSE_REASON_LABEL,
  UPDATE_CLOSE_REASON_STATUS,
} from './closeReasons';

import { bpfDepartmentAPI } from './departments';

export * from './stages';
export * from './templates';
export * from './closeReasons';

export const bpfAPI = {
  fetchTemplates: GET_TEMPLATES,
  fetchTemplateById: GET_TEMPLATE_BY_ID,
  fetchStagesByDepartment: GET_STAGES_BY_DEPARTMENT,
  fetchVOTemplatesAndStages: GET_VO_TEMPLATES_AND_STAGES,
  fetchCSTemplatesAndStages: GET_CS_TEMPLATES_AND_STAGES,

  completeStage: COMPLETE_STAGE,
  createTemplate: CREATE_TEMPLATE,
  updateTemplate: UPDATE_TEMPLATE,
  updateStageFields: UPDATE_STAGE_FIELDS,
  setActiveStatus: SET_TEMPLATE_ACTIVE_STATUS,
  updateStageForDepartment: UPDATE_CURRENT_STAGE_FOR_DEPARTMENT,

  fetchCloseReasons: GET_CLOSE_REASONS,
  deleteCloseReason: DELETE_CLOSE_REASON,
  createCloseReason: CREATE_CLOSE_REASON,
  createCloseReasons: CREATE_CLOSE_REASONS,
  updateCloseReasonLabel: UPDATE_CLOSE_REASON_LABEL,
  updateCloseReasonStatus: UPDATE_CLOSE_REASON_STATUS,
  fetchCloseReasonsOptions: GET_CLOSE_REASONS_OPTIONS,

  getStageNotes: GET_STAGE_NOTES,
  createStageNote: CREATE_STAGE_NOTE,
  fetchStagesTimeline: GET_STAGES_TIMELINE,

  department: bpfDepartmentAPI,
};
